import * as React from 'react';
import { Invoice, PaymentDetails } from 'fs-api-client';
import { createBillingApi } from '../utils/createApi';
import { formatAmount, getDateFormatWithoutDay } from '../utils/utilFunctions';
import { CheckMarkIcon, CreditCardIcon, Spinner, CircledCrossIcon } from './common/Icons';

export interface PaySingleInvoiceModalState {
    paymentState: PaymentState;
}

enum PaymentState {
    PaymentNotStarted,
    PaymentBeingProcessed= 'Your payment is being processed.',
    PaymentSuccess = 'Your payment was successful.',
    PaymentFailed = 'Your payment failed. Please contact your bank for more details.'
}

export interface PaySingleInvoiceModalProps {
    invoice: Invoice;
    paymentDetails: PaymentDetails;
    onPaymentSuccessful: () => void;
}

export class PaySingleInvoiceModal extends React.Component<PaySingleInvoiceModalProps, PaySingleInvoiceModalState> {
    constructor(props: PaySingleInvoiceModalProps) {
        super(props);
        this.paymentProcessHandler = this.paymentProcessHandler.bind(this);
        this.renderPaymentSuccessfulElement = this.renderPaymentSuccessfulElement.bind(this);
        this.renderPaymentElement = this.renderPaymentElement.bind(this);
        this.renderWaitingForPaymentSuccessElement = this.renderWaitingForPaymentSuccessElement.bind(this);
        this.paySingleInvoice = this.paySingleInvoice.bind(this);
        this.resetModalState = this.resetModalState.bind(this);
        this.state = {
            paymentState: PaymentState.PaymentNotStarted
        };
    }

    render() {
        return (
            <div className="modal fade modal-vertical" id="paySingleInvoiceModal" tabIndex={-1} role="dialog" aria-labelledby="filespaceBreakdownModal" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div>
                                <CreditCardIcon className="icon" width="27px" />
                                <h2>Invoice payment</h2>
                                <p>{getDateFormatWithoutDay(this.props.invoice.date)}</p>
                            </div>
                            <button onClick={this.resetModalState} id="paySingleInvoiceModal" type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">
                                    <CircledCrossIcon width="20px" height="20px" />
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div className="billing-card">
                                    <div className="overlay">
                                        <span>Billing name</span>
                                        {this.props.paymentDetails.description}
                                    </div>
                                    <div>
                                        <span>Credit card</span>
                                        **** **** **** {this.props.paymentDetails.card!.numberLast4}
                                    </div>
                                </div>

                            </div>
                        </div>
                        {this.paymentProcessHandler(this.state.paymentState)}
                    </div>
                </div>
            </div>
        );
    }

    private paymentProcessHandler(paymentState: PaymentState): JSX.Element {
        switch (paymentState) {
            case PaymentState.PaymentNotStarted:
                return this.renderPaymentElement();
            case PaymentState.PaymentBeingProcessed:
                return this.renderWaitingForPaymentSuccessElement();
            case PaymentState.PaymentSuccess:
                return this.renderPaymentSuccessfulElement();
            case PaymentState.PaymentFailed:
                return this.renderPaymentFailedElement();
            default:
                return this.renderPaymentElement();
        }
    }

    private renderPaymentElement(): JSX.Element {
        return (
            <footer>
                <div>
                    <button onClick={this.paySingleInvoice} className="pay-button">
                        Pay {formatAmount(this.props.invoice.amountDue, this.props.invoice.currency)}
                    </button>
                </div>
                <a onClick={this.resetModalState} data-dismiss="modal" href="javascript:void(0)">Cancel</a>
            </footer>
        );
    }

    private resetModalState(): void {
        this.setState({paymentState: PaymentState.PaymentNotStarted});
    }

   private renderWaitingForPaymentSuccessElement(): JSX.Element {
        return (
            <footer>
                <div className="sync-element" id="syncElement">
                    <Spinner width="23px" height="25px" />
                </div>
                <span>
                    Proceed
                </span>
            </footer>
        );
    }

    private renderPaymentSuccessfulElement(): JSX.Element {
        return (
            <footer>
                <div className="icon">
                    <CheckMarkIcon width="28px" height="20px" />
                </div>
                <span>
                    Done
                </span>
            </footer>
        );
    }

    private renderPaymentFailedElement(): JSX.Element {
        return (
            <footer className="warning">
                <span>
                    Your payment failed. Please contact your bank or support@lucidlink.com.
                </span>
            </footer>
        );
    }

    private async paySingleInvoice(): Promise<void> {
        if (!this.props.invoice) { return ; }
        const billingApi = await createBillingApi();
        try {
            this.setState({paymentState: PaymentState.PaymentBeingProcessed});
            await billingApi.payInvoice({id: this.props.invoice.id});
            this.setState({paymentState: PaymentState.PaymentSuccess});
            await this.props.onPaymentSuccessful();
        } catch (e) {
            this.setState({paymentState: PaymentState.PaymentFailed});
        }
    }
}


// WEBPACK FOOTER //
// ./src/webportal/components/PaySingleInvoiceModal.tsx